import { extractRoleProperties } from '@shared/hooks/helpers/OrganizationalHelpers';
import useRelativeTime from '@shared/hooks/useRelativeTime';
import OrganizationMemberInviteModel from '@shared/models/organizations/OrganizationMemberInviteModel';
import { useTranslation } from 'react-i18next';
import { OrgDetailItemsWrapper, OrgDetailWrapper } from '../CommonOrgStyles';
import MemberDetailItem from '../member/MemberDetailItem';
import RoleIconList from '../role/RoleIconList';

interface IInviteDetailStackProps {
    invite: OrganizationMemberInviteModel;
    hideEmail?: boolean;
    hideWrapper?: boolean;
}

export default function InviteDetailStack({ invite, hideEmail, hideWrapper }: Readonly<IInviteDetailStackProps>) {
    const { t } = useTranslation();
    const getRelativeTime = useRelativeTime();

    if (!invite) return null;
    const content = (
        <OrgDetailItemsWrapper>
            {!hideEmail && <MemberDetailItem icon="mail" title={invite.email} />}
            <RoleIconList variant="listOnly" role={extractRoleProperties(invite)} />
            <MemberDetailItem
                iconSize={16}
                variant="small"
                icon="orgInviteExpired"
                title={t('common:organization.invite.expiration') + getRelativeTime(new Date(invite.expirationDate))}
            />
        </OrgDetailItemsWrapper>
    );

    return hideWrapper ? content : <OrgDetailWrapper>{content}</OrgDetailWrapper>;
}
